import { format, isValid, parse } from 'date-fns';

export const getMonthNames = () => Array.from({ length: 12 }, (_, index) => format(new Date(0, index), 'MMMM'));

export type DateParts = {
  day: string;
  month: string;
  year: string;
};

export const EMPTY_DATE_PARTS = {
  day: '',
  month: '',
  year: '',
} satisfies DateParts;

export const toDatePartsFromString = (dateString: string) => {
  const date = dateString ? parse(dateString, 'yyyy-MM-dd', new Date()) : undefined;

  return date && isValid(date)
    ? {
        day: date.getDate().toString(),
        month: (date.getMonth() + 1).toString(),
        year: date.getFullYear().toString(),
      }
    : {
        day: '',
        month: '',
        year: '',
      };
};

export const toDateFromParts = (dateParts: DateParts) => parse(`${dateParts.year}-${dateParts.month}-${dateParts.day}`, 'yyyy-M-d', new Date());

export const isDatePartsValid = (dateParts: DateParts) => isValid(toDateFromParts(dateParts));

export const toDateStringFromParts = (dateParts: DateParts) => format(new Date(Number(dateParts.year), Number(dateParts.month) - 1, Number(dateParts.day)), 'yyyy-MM-dd');
